// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-tag-image[data-v-f1df57fc]{min-width:150px}.avatar-tag-image.--dyot[data-v-f1df57fc]{padding:0 19px}", ""]);
// Exports
module.exports = exports;
